import React from 'react';
import { FaPencilAlt } from "react-icons/fa";

const Header = ({ visitorName, isEditingName, onNameEdit, onNameSubmit, nameInputRef, onClearChat }) => {
    return (
        <div className="hidden sm:flex bg-cyber-gray/30 backdrop-blur-sm px-4 py-2 items-center justify-between border-b border-white/10">
            <div className="flex items-center space-x-2">
                <div className="w-3 h-3 rounded-full bg-[#ff5f57]" />
                <div className="w-3 h-3 rounded-full bg-[#febc2e]" />
                <div className="w-3 h-3 rounded-full bg-[#28c840]" />
                {isEditingName ? (
                    <form onSubmit={onNameSubmit} className="ml-2">
                        <input
                            ref={nameInputRef}
                            type="text"
                            defaultValue={visitorName}
                            className="bg-transparent border-b border-primary/20 focus:border-primary/60 outline-none px-1 font-mono text-primary/80"
                            onBlur={onNameSubmit}
                        />
                    </form>
                ) : (
                    <button
                        onClick={onNameEdit}
                        className="ml-2 font-mono text-primary/80 flex items-center space-x-1 hover:text-primary transition-colors"
                    >
                        <span>{visitorName}</span>
                        <FaPencilAlt className="w-3 h-3 opacity-60" />
                    </button>
                )}
            </div>
            <button
                onClick={onClearChat}
                className="text-primary/60 text-xs font-mono hover:text-primary/80 px-2 py-1 rounded border border-white/10 hover:border-white/20"
            >
                Clear Chat
            </button>
        </div>
    );
};

export default Header; 